import PropTypes from "prop-types"
import React, { useState, useCallback, useRef, useMemo, useEffect } from "react"

import {
  Container,
  Card,
  CardBody,
  Button,
  Label,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  TabContent,
  TabPane,
  Progress,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap"
import { Link, useNavigate, useLocation, useParams } from "react-router-dom"
import Select from "react-select"
import moment from "moment"
import chevleft from "assets/images/services-icon/chev-left.png"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"


//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import Loader from "react-spinner-loader"
//datatable
import { SECURITY_KEY, BASE_URL } from "../../global"

const ManualMark = props => {
  //datatable
  const { key } = useParams()
  const location = useLocation()
  useEffect(() => {
    if (key && key != "") {
    } else {
      toast.error("Sorry, Key missing!", {
        autoClose: 3000, // 3 seconds in this example
        onClose: () => {
          window.history.back()
        },
      })
    }
  }, [location])
  const [data, setData] = useState([])
  const [records, setRecords] = useState([])
  // Status filter: "3"=All, "1"=Completed, "0"=Incomplete (matches la.status)
  const statusOptions = useMemo(
    () => [
      { label: "All", value: "3" },
      { label: "Completed", value: "1" },
      { label: "Incomplete", value: "0" },
    ],
    []
  )
  const defaultSelectedGroup = "1" // Completed
  const [selectedGroup, setselectedGroup] = useState(defaultSelectedGroup)
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  const getFilteredRecords = useCallback((sourceData, inputValue = "", statusValue = "1") => {
    const search = (inputValue || "").toLowerCase()
    return (sourceData || []).filter(row => {
      const studentName =
        row.st_first_name && row.st_first_name !== ""
          ? row.st_first_name + " " + row.st_surname
          : "-"
      const sessionName =
        row.sest_name != null && row.sest_name !== "" ? row.sest_name : "-"
      const sessionDate =
        row.ses_date != null && row.ses_date !== ""
          ? moment(row.ses_date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
              "DD-MM-YYYY"
            )
          : "-"
      const lessonType =
        parseInt(row.marked_for_homework) === 1 ? "HomeWork" : "Lesson"
      const activityNode =
        row.activity_node != null && row.activity_node !== ""
          ? row.activity_node
          : "-"
      const statusLabel =
        parseInt(row.status) === 1 ? "Completed" : "Incomplete"

      const inputMatch =
        !search ||
        studentName.toLowerCase().includes(search) ||
        sessionName.toLowerCase().includes(search) ||
        sessionDate.includes(search) ||
        lessonType.toLowerCase().includes(search) ||
        activityNode.toLowerCase().includes(search) ||
        statusLabel.toLowerCase().includes(search)

      // "3" = All; otherwise match activity status 0/1
      const statusMatch =
        !statusValue ||
        statusValue === "3" ||
        parseInt(row.status, 10) === parseInt(statusValue, 10)

      return inputMatch && statusMatch
    })
  }, [])

  function handleSelectGroup(nextGroup) {
    const statusValue =
      nextGroup && typeof nextGroup === "object" ? nextGroup.value : nextGroup
    setselectedGroup(statusValue)
    setRecords(getFilteredRecords(data, searchTerm, statusValue))
  }

  function handleFilter(event) {
    const inputValue = event.target.value.trimStart().toLowerCase()
    setSearchTerm(inputValue)
    setRecords(getFilteredRecords(data, inputValue, selectedGroup))
  }

  const toggleRightCanvas = studentKey => {}

  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }

  // const [date, setDate] = useState(new Date());
  const [date, setDate] = useState([null, null])

  const [subject, setSubject] = useState("")
  const [type, setType] = useState("")
  const [status, setStatus] = useState("")

  const [startDate, setStartDate] = useState("")
  const handelDateReset = () => {
    setStartDate("")
  }

  //Kathir start
  const [isFilter, setFilter] = useState(false)
  const [isChecked, setChecked] = useState(true)
  const selectedStatusOption =
    statusOptions.find(option => String(option.value) === String(selectedGroup)) ||
    statusOptions.find(option => option.value === defaultSelectedGroup)

  const handleCheckboxChange = () => {
    setChecked(!isChecked) // Toggle the checkbox state
  }

  const navigate = useNavigate()
  //Kathir end
  const authUser = JSON.parse(localStorage.getItem("authUser")) || null

  const fetchData = async () => {
    try {
      if (authUser && authUser != "" && authUser != null) {
        if (
          sessionStorage.getItem("UnplanedLesson") &&
          sessionStorage.getItem("UnplanedLesson") == "true"
        ) {
          setChecked(true)
          sessionStorage.removeItem("UnplanedLesson")
        }
        setLoading(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const response = await axios.post(
          BASE_URL + "session/getSessionsActivityManualDetails",
          {
            draw: 1,
            start: 0,
            length: -1,
            order: [{ column: 0, dir: "asc" }],
            columns: [
              { data: "session_date" },
              { data: "session_time" },
              { data: "sest_name" },
              { data: "total_student" },
              { data: "subject" },
              { data: "sest_type" },
              { data: "ses_is_completed" },
            ],
            search: { value: "" },
            startDate: date[0] || null,
            endDate: date[1] || null,
            pk_student_key: key,
            subject: subject,
            type: type,
            status: status,
          }
        )
        if (response.data.length > 0) {
          setData(response.data)
          setRecords(
            getFilteredRecords(response.data, searchTerm, selectedGroup)
          )
          setLoading(false)
        } else {
          setData([])
          setRecords([])
          setLoading(false)
        }
      } else {
        navigate("/login")
        setLoading(false)
      }

      // setAllData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error)
      if (
        error?.response?.status &&
        (error?.response?.status === 403 || error?.response?.status === 401) &&
        (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
      ) {
        localStorage.clear()
        navigate("/login")
      }
      setLoading(false)
    }
  }

  const filterApply = () => {
    toggleRightCanvas()
    setFilter(!isFilter)
  }

  const filterReset = () => {
    setselectedGroup("3")
    setSearchTerm("")
    setChecked(false)
    setFilter(!isFilter)
    setRecords(getFilteredRecords(data, "", "3"))
  }

  useEffect(() => {
    fetchData()
  }, [])

  // const products = [
  //   {
  //     id: 1,
  //     name: "John Doe",
  //     level: "Intermediate",
  //     school: "ABC School",
  //     sessions: 10,
  //     attended: 7,
  //     nextsession: "2024-02-10",
  //   },
  //   {
  //     id: 2,
  //     name: "Jane Smith",
  //     level: "Advanced",
  //     school: "XYZ School",
  //     sessions: 15,
  //     attended: 12,
  //     nextsession: "2024-02-12",
  //   },
  //   {
  //     id: 3,
  //     name: "Michael Johnson",
  //     level: "Beginner",
  //     school: "123 School",
  //     sessions: 8,
  //     attended: 6,
  //     nextsession: "2024-02-08",
  //   },
  //   {
  //     id: 4,
  //     name: "Emily Brown",
  //     level: "Intermediate",
  //     school: "456 School",
  //     sessions: 12,
  //     attended: 10,
  //     nextsession: "2024-02-11",
  //   },
  //   // Add more product data as needed
  // ]

  const columns = useMemo(
    () => [
      {
        name: "Student Name",
        Header: "Student Name",
        // accessor: 'st_first_name',
        accessor: row =>
          row.st_first_name && row.st_first_name != ""
            ? row.st_first_name + " " + row.st_surname
            : "-",
      },
      {
        name: " Session Name",
        Header: " Session Name",
        accessor: row =>
          row.sest_name != null && row.sest_name != "" ? row.sest_name : "-",
      },
      {
        name: "Session Date",
        Header: "Session Date",
        accessor: row =>
          row.ses_date != null && row.ses_date != ""
            ? moment(row.ses_date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
                "DD-MM-YYYY"
              )
            : "-",
      },
      {
        name: "Activity",
        Header: "Activity",
        accessor: row =>
          parseInt(row.marked_for_homework) === 1 ? "HomeWork" : "Lesson",
      },
      {
        name: "Activity Name",
        Header: "Activity Name",
        accessor: row =>
          row.activity_node != null && row.activity_node != ""
            ? row.activity_node
            : "-",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          const rowValue = row.original
          if (parseInt(rowValue.status) === 1) {
            return <button className="btn tb-success tb-bdge">Completed</button>
          }
          return (
            <button className="btn tb-primary text-white tb-bdge">
              Incomplete
            </button>
          )
        },
      },
      {
        Header: "",
        accessor: "pk_lesson_activity_question_id",
        Cell: ({ row }) => (
          <button
            className="btn p-0 hgt"
            onClick={() => onManualMarkingActivity(row.original)}
          >
            <i
              className="mdi mdi-chevron-right-circle-outline"
              style={{ color: "#979797", fontSize: "24px" }}
            ></i>
          </button>
        ),
      },
    ],
    []
  )

  const visibleColumns = useMemo(
    () => columns.filter(column => column.show !== false && column.isVisible !== false),
    [columns]
  )

  const getCellValue = (column, row) => {
    if (typeof column.Cell === "function") {
      return column.Cell({ row: { original: row } })
    }

    if (typeof column.accessor === "function") {
      return column.accessor(row)
    }

    if (typeof column.accessor === "string") {
      return row[column.accessor] ?? "-"
    }

    return "-"
  }

  // const paginationOptions = {
  //   paginationSize: 5,
  //   pageStartIndex: 1,
  //   firstPageText: "First",
  //   prePageText: "Back",
  //   nextPageText: "Next",
  //   lastPageText: "Last",
  //   nextPageTitle: "First page",
  //   prePageTitle: "Pre page",
  //   firstPageTitle: "Next page",
  //   lastPageTitle: "Last page",
  // }

  //tab

  // const [activeTab, setActiveTab] = useState("1");

  // const toggleTab = (tab) => {
  //   if (activeTab !== tab) {
  //     setActiveTab(tab);
  //   }
  // };

  function onManualMarkingActivity(activityDetails) {
    if (activityDetails && parseInt(activityDetails.status) === 1) {
      if (activityDetails && (parseInt(activityDetails.activity_type) === 0 || parseInt(activityDetails.activity_type) === 8)) {
        if (
          activityDetails.pk_lesson_activity_key &&
          activityDetails.fk_sub_id &&
          activityDetails.fk_student_key
        ) {
          navigate(
            `/manual-assessment/${activityDetails.pk_lesson_activity_key}`,
            {
              state: {
                type: `${activityDetails.fk_sub_id}`,
                st_key: `${activityDetails.fk_student_key}`,
              },
            }
          )
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      } else if (
        activityDetails &&
        parseInt(activityDetails.activity_type) === 5
      ) {
        if (
          activityDetails.pk_lesson_activity_key &&
          activityDetails.fk_sub_id &&
          activityDetails.fk_student_key
        ) {
          navigate(
            `/manual-worksheet/${activityDetails.pk_lesson_activity_key}`,
            {
              state: {
                type: `${activityDetails.fk_sub_id}`,
                st_key: `${activityDetails.fk_student_key}`,
              },
            }
          )
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      } else if (
        activityDetails &&
        parseInt(activityDetails.activity_type) === 7
      ) {
        if (
          activityDetails.pk_lesson_activity_key &&
          activityDetails.fk_sub_id &&
          activityDetails.fk_student_key
        ) {
          navigate(
            `/manual-lcms-worksheet/${activityDetails.pk_lesson_activity_key}`,
            {
              state: {
                type: `${activityDetails.fk_sub_id}`,
                st_key: `${activityDetails.fk_student_key}`,
              },
            }
          )
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000, // 3 seconds in this example
        })
      }
    } else {
      toast.error("Sorry, Activity not completed", {
        autoClose: 3000, // 3 seconds in this example
      })
    }
  }

  function handleFilter1(event) {
    const inputValue = event.target.value.trim().toLowerCase()
    const newData = data.filter(row => {
      return (
        (row.st_first_name && row.st_first_name != ""
          ? row.st_first_name + " " + row.st_surname
          : "-"
        )
          .toLowerCase()
          .includes(inputValue) ||
        (row.sest_name != null && row.sest_name != "" ? row.sest_name : "-")
          .toLowerCase()
          .includes(inputValue) ||
        (row.ses_date != null && row.ses_date != ""
          ? moment(row.ses_date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
              "DD-MM-YYYY"
            )
          : "-"
        ).includes(inputValue) ||
        (parseInt(row.marked_for_homework) === 1 ? "HomeWork" : "Lesson")
          .toLowerCase()
          .includes(inputValue) ||
        (row.activity_node != null && row.activity_node != ""
          ? row.activity_node
          : "-"
        )
          .toLowerCase()
          .includes(inputValue) ||
        (parseInt(row.status) === 1 ? "Completed" : "Incomplete")
          .toLowerCase()
          .includes(inputValue)
      )
    })
    setRecords(newData)
  }

  const [activeTab1, setActiveTab1] = useState("5")

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setActiveTab1(tab)
    }
  }

  //modal
  const [modal_center, setmodal_center] = useState(false)
  const tog_center = () => {
    setmodal_center(!modal_center)
  }

  const [modal_center1, setmodal_center1] = useState(false)
  const tog_center1 = () => {
    setmodal_center1(!modal_center1)
  }

  // Function to handle date change
  const handleDateChange = date => {
    setStartDate(date)
    // Here you can implement logic to fetch data for the selected month
    // and update the chart accordingly
  }

  // // Function to generate labels and data for the last six months
  // const generateLastSixMonthsData = () => {
  //   const labels = [];
  //   const dataPoints = [];
  //   let currentDate = new Date();
  //   for (let i = 0; i < 6; i++) {

  //     console.log(currentDate.getMonth());
  //     console.log(currentDate.getMonth());
  //     labels.unshift(currentDate.toLocaleString('default', { month: 'long' }));
  //     // Replace this with actual data-fetching logic based on the current month
  //     dataPoints.unshift(Math.floor(Math.random() * 100)); // Sample random data
  //     currentDate.setMonth(currentDate.getMonth() - 1);
  //   }
  //   return { labels, dataPoints };
  // };

  // const { labels, dataPoints } = generateLastSixMonthsData();

  // console.log(labels);

  // console.log(TopicGraphDeatils.LabelData);

  return (
    <div className="page-content">
      <Loader
        show={loading}
        type="body"
        // stack="vertical"
        // message="Loading Data"
      />
      <ToastContainer autoClose={3000} />
      <Container fluid>
        <div className="page-title-box d-flex">
          <div className="custom-pg_header flex-wrap gap-2 mb-2">
            <div>
              <div className="d-flex align-items-center">
                <div className="short-ic" onClick={() => window.history.back()}>
                  <img className="bc-bg2 mr-30" src={chevleft} />
                </div>
                <div>
                  <h6
                    className="page-title inner-pg-title mb-0"
                    style={{ width: "17vw" }}
                  >
                    {" "}
                    Activity List
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <form className="app-search page-search w-60">
            <div className="position-relative">
              <span className="ion ion-ios-search"></span>
              <input
                type="text"
                className="form-control"
                placeholder="Search for session Details..."
                value={searchTerm}
                onChange={handleFilter}
              />
            </div>
          </form>
        </div>

        <div className="d-flex mt-3 mb-3 align-items-end">
          <div className="filter-child me-3">
            <label>Status</label>
            <Select
              className="stud_level"
              value={selectedStatusOption}
              onChange={handleSelectGroup}
              options={statusOptions}
              classNamePrefix="select2-selection"
              isSearchable={false}
              isClearable={false}
              placeholder="Select status"
              menuPortalTarget={
                typeof document !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                singleValue: base => ({
                  ...base,
                  color: "#212529",
                  opacity: 1,
                }),
                option: (base, state) => ({
                  ...base,
                  color: state.isSelected || state.isFocused ? "#fff" : "#212529",
                }),
              }}
            />
          </div>

          {/* <div className="form-check mt-4 ms-3 d-flex">
            <input
              type="checkbox"
              className="form-check-input check_box"
              id="unplannedLesson"
              checked={isChecked} // Control the checkbox state
              onChange={handleCheckboxChange}
            />

            <label className="form-check-label mb-0" htmlFor="unplannedLesson">
              Unplanned lessons (next 7 days)
            </label>
          </div>
          */}
          <div className="col-3 ms-3 mb-0">
            <button
              type="button"
              className="btn btn btn-primary filter-btn mt-0"
              onClick={filterReset}
            >
              Clear Filter
            </button>
          </div>
        </div>

        <div
          className="student_table"
          style={{
            maxHeight: "calc(100vh - 220px)",
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <table className="table mb-0">
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "var(--color-gainsboro-400, #e9ecef)",
              }}
            >
              <tr>
                {visibleColumns.map((column, index) => (
                  <th key={column.Header || column.accessor || index} className="cus-td">
                    {column.Header || ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {records && records.length > 0 ? (
                records.map((row, rowIndex) => (
                  <tr
                    key={
                      row.pk_lesson_activity_key ||
                      row.pk_lesson_activity_question_id ||
                      rowIndex
                    }
                    className="cursor-pointer list-cus-h cus-tr"
                  >
                    {visibleColumns.map((column, colIndex) => (
                      <td
                        key={column.Header || column.accessor || colIndex}
                        className="cus-td"
                      >
                        {getCellValue(column, row)}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={visibleColumns.length || 1}>
                    <p className="text-center mb-0">No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Container>
    </div>
  )
}

// Dashboard.propTypes = {
//   t: PropTypes.any
// };

export default withTranslation()(ManualMark)
